import Home from './Home/Home.vue';

import LoginReportes from './Reportes/LoginReportes.vue';
import Reportes from './Reportes/Reportes.vue';

import MaestrosDeLaParrilla from './Home/MaestrosDeLaParrilla.vue';

import LoginWidget from './Widgets/LoginWidget.vue';
import RecuperacionWidget from './Widgets/RecuperacionWidget.vue';

import Cursos from './Dashboard/Cursos/Cursos.vue';
import Avance from './Dashboard/Cursos/Avance.vue';
import CursosVideo from './Dashboard/Cursos/Video.vue';
import Subcurso from './Dashboard/Cursos/Subcurso.vue';


import Videorecetas from './Dashboard/Videorecetas/Videorecetas.vue';
import VideoVideoReceta from './Dashboard/Videorecetas/VideoVideoReceta.vue';


import CursosQuizMultiple from './Dashboard/Cursos/QuizMultiple.vue';
import CursosQuizOrden from './Dashboard/Cursos/QuizOrden.vue';
import CursosQuizColumnas from './Dashboard/Cursos/QuizColumnas.vue';
import CursosQuizEliminacion from './Dashboard/Cursos/QuizEliminacion.vue';

import CursosQuizResultado from './Dashboard/Cursos/QuizResultado.vue';

import Certificado from './Dashboard/Cursos/Certificado.vue';

import Registro from './Registro/Registro.vue';
import Verificacion from './Registro/Verificacion.vue';
import Olvido from './Registro/Olvido.vue';


import Recetario from './Recetario/Recetario.vue';

import Terminos from './TerminosYCondiciones/TerminosYCondiciones.vue';


import Dashboard from './Dashboard/Dashboard.vue';

import cookie from 'vue-cookie';

export const routes = [
    { path: '', component: Home },
    { path: '/', component: Home },

    // { path: '/reportes', component: LoginReportes },

    // { path: '/maestros-de-la-parrilla', component: MaestrosDeLaParrilla },
    // { path: '/registro', component: Registro },
    // { path: '/verificacion/:email', component: Verificacion },
    // { path: '/recuperacion', component: Olvido },

    /*widgets*/
    // { path: '/login-widget', component: LoginWidget },
    // { path: '/recuperacion-widget', component: RecuperacionWidget },

    /*protegidas*/
    //{ path: '/reportes/dashboard', component: Reportes, beforeEnter(to, from, next) { protectReportes(next) } },


    {
        path: '/dashboard',
        name: 'Categorías',
        component: Dashboard,
        beforeEnter(to, from, next) { protect(next) }
    },

    {
        path: '/administrador',
        name: 'Administrador',
        component: () =>
            import ( /* webpackChunkName: "login" */ './Reportes/LoginReportes.vue'),
    },
    {
        path: '/administrador/dashboard',
        name: 'Informe',
        component: () =>
            import ( /* webpackChunkName: "login" */ './Reportes/Reportes.vue'),
        meta: {
            requiresAuthAdmin: true
        },
        beforeEnter(to, from, next) { protectReportes(next) }
    },

    {
        path: '/curso/:id',
        component: CursosVideo,
        props: true,
        beforeEnter(to, from, next) { protect(next) }
    },

    {
        path: '/curso/:tipo/:id',
        component: Subcurso,
        props: true,
        beforeEnter(to, from, next) { protect(next) }
    },


    // // // { path: '/cursos', component: Cursos, beforeEnter(to, from, next) { protect(next) } },
    // // // { path: '/cursos/avance', component: Avance, beforeEnter(to, from, next) { protect(next) } },
    // // // { path: '/cursos/video/:id', component: CursosVideo, props: true, beforeEnter(to, from, next) { protect(next) } },

    // // // { path: '/videorecetas', component: Videorecetas, beforeEnter(to, from, next) { protect(next) } },
    // // // { path: '/videorecetas/video/:id', component: VideoVideoReceta, props: true, beforeEnter(to, from, next) { protect(next) } },

    // // // { path: '/cursos/quiz/multiple/:id/:paso', component: CursosQuizMultiple, props: true, beforeEnter(to, from, next) { protect(next) } },
    // // // { path: '/cursos/quiz/orden/:id/:paso', component: CursosQuizOrden, props: true, beforeEnter(to, from, next) { protect(next) } },
    // // // { path: '/cursos/quiz/columnas/:id/:paso', component: CursosQuizColumnas, props: true, beforeEnter(to, from, next) { protect(next) } },
    // // // { path: '/cursos/quiz/eliminacion/:id/:paso', component: CursosQuizEliminacion, props: true, beforeEnter(to, from, next) { protect(next) } },

    // // // { path: '/cursos/resultado/:id', component: CursosQuizResultado, props: true, beforeEnter(to, from, next) { protect(next) } },

    // // // { path: '/cursos/certificado/', component: Certificado, props: true, beforeEnter(to, from, next) { protect(next) } },

    // // // { path: '/recetario', component: Recetario, beforeEnter(to, from, next) { protect(next) } },

    /*{ path: '/registro', component: Registro },
     */

    //{ path: '/dashboard/', component: Dashboard, beforeEnter(to, from, next) { protect(next) } },


];


function protect(next) {
    //if (cookie.get('useracademiadigital') != null) {
    if (localStorage.getItem('useracademiadigital') != null && localStorage.getItem('useracademiadigital') != "") {
        next();
    } else {
        //cookie.delete("useracademiadigital");
        localStorage.removeItem('useracademiadigital');
        next('/');
    }
}

function protectReportes(next) {
    //if (cookie.get('useracademiadigital') != null) {
    if (localStorage.getItem('useracademiadigitalreportes') != null && localStorage.getItem('useracademiadigitalreportes') != "") {
        next();
    } else {
        //cookie.delete("useracademiadigital");
        //localStorage.removeItem('useracademiadigitalreportes');
        next('/administrador');
    }
}